import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { EmailFunnelResponse } from 'src/app/core/models/analytics/es-models';
import { PopupHostComponent } from 'src/app/core/components/popup-host.component';
import { BreakthroughIncidentsAnalysisComponent } from './components/breakthrough-incidents-analysis.component';

@Component({
  selector: 'app-es-distillation-funnel',
  templateUrl: './es-distillation-funnel.component.html',
  styleUrls: ['./es-distillation-funnel.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonsModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EsDistillationFunnelComponent extends PopupHostComponent {
  // Expose Math object to the template
  Math = Math;

  emailFunnel = input<EmailFunnelResponse>(new EmailFunnelResponse());
  organizationId = input<number | null>(null);

  public openBreakthroughAnalysis(): void {
    const options = {
      animate: { type: 'slide', direction: 'left', duration: 300 },
      anchorAlign: { horizontal: 'right', vertical: 'top' },
      popupAlign: { horizontal: 'right', vertical: 'top' },
    };

    this.openPopup(this.bodyElement, BreakthroughIncidentsAnalysisComponent, options);

    setTimeout(() => {
      const analysisComponent = this.popupRef?.content.instance as BreakthroughIncidentsAnalysisComponent;
      if (analysisComponent) {
        analysisComponent.organizationId = this.organizationId();

        analysisComponent.close.subscribe(() => {
          this.closePopup();
        });
      }
    });
  }
}
